export default __webpack_public_path__ + "static/media/Black Dragon Cloak.9181194b.jpg";